const managerRoles = ['engineer-manager', 'non-engineer-manager']

export const isUserManagerRole = (type: string) => {
  return managerRoles.includes(type)
}
